export default {
  store(task) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/crms/tasks', { task });
  },
  index(task) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/crms/tasks?list', task.filter);
  },
  // fetchTags() {
  //     return axios.get("/api/apps/todo/tags")
  // },
  update(task) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/crms/tasks/' + task.id, { task });
  },
};

